import { render, staticRenderFns } from "./agentRoleModal.vue?vue&type=template&id=1981b885"
import script from "./agentRoleModal.vue?vue&type=script&lang=js"
export * from "./agentRoleModal.vue?vue&type=script&lang=js"
import style0 from "./agentRoleModal.vue?vue&type=style&index=0&id=1981b885&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports